import { createContext } from 'react';

export type FeatureFlagsState = Record<string, boolean>;

export const FeatureFlagsContext = createContext<FeatureFlagsState>({});
